module.exports = __webpack_public_path__ + "d7a8f44198ac872f8b35a6f37e22a983.jpg";